/* eslint-disable @next/next/no-page-custom-font */
import Head from 'next/head';
import GoogleTagManager from '@/components/layout/GoogleTagManager';
import { StoreConfModel } from '@/models';
import { CDN_SERVER_URL, STATIC_SERVER_URL } from '@/constants/urls';

type HeadMillesimaProps = {
  storeConf: StoreConfModel;
}

export const HeadMillesima = ({ storeConf }: HeadMillesimaProps) => {
  const { logo, googleSiteVerification, googleSiteVerification2 } = storeConf;
  const enableGTM = process.env.NEXT_PUBLIC_NOGTM !== 'true';

  return (
    <Head>
      {<GoogleTagManager/>}
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {googleSiteVerification && (
        <meta name="google-site-verification" content={googleSiteVerification} />
      )}
      {googleSiteVerification2 && (
        <meta name="google-site-verification" content={googleSiteVerification2} />
      )}
      {/* Domain verification for Pinterest*/}
      <meta name="p:domain_verify" content="e1386b529b036411eb0d42d388066ca5"/>

      <link rel="preload" href={logo} as="image" />
      <link rel="preconnect" href={STATIC_SERVER_URL} />
      <link rel="preconnect" href="https://www.googletagmanager.com" crossOrigin="anonymous" />

      {/*
        Use dns-prefetch as a fallback for old browsers
        where preconnect is not implemented (i.e. IE11)
        https://web.dev/preconnect-and-dns-prefetch/#resolve-domain-name-early-with-reldns-prefetch
       */}
      <link rel="dns-prefetch" href={STATIC_SERVER_URL} />
      <link
        rel="shortcut icon"
        href={`${CDN_SERVER_URL}/attachements/favicon.ico`}
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-60px.png`}
        sizes="60x60"
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-72px.png`}
        sizes="72x72"
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-76px.png`}
        sizes="76x76"
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-114px.png`}
        sizes="114x114"
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-120px.png`}
        sizes="120x120"
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-144px.png`}
        sizes="144x144"
      />
      <link
        rel="apple-touch-icon-precomposed"
        href={`${CDN_SERVER_URL}/touchicon/touch-icon-152px.png`}
        sizes="152x152"
      />
    </Head>
  );
};

export default HeadMillesima;
